import { AuthSession } from 'aws-amplify/auth';
import { atomWithStorage } from 'jotai/utils';

export const isCognitoAuth = (v: any): v is AuthSession => {
  return Boolean(v?.tokens);
};

type BackendAuthToken = {
  jwt: string;
};

/**
 * This is deprecated, but there are some things we still not have a good solution on.
 *
 * In particular we run a hybrid setup where we can both authenticate towards our own backend and
 * cognito. We use our own backed in development and cognito in production.
 *
 * We need to rework this into using services instead of relying on this.
 *
 * This will give a lot of downstream simplifications
 */
export const authStateAtom = atomWithStorage<
  AuthSession | BackendAuthToken | null
>('authStateAtom', null);
